import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import { BarcodeIcon, HouseIcon, SupportsIcon, ThreeStarIcon, WrappedGiftIcon } from './CustomIcon';
import { urlAwardsPage, urlBarcodePage, urlNotifPage, urlSupportPage, urlTopsPage } from 'services/utils/globalVariables';
import { Badge, styled } from '@mui/material';
import { useContextState } from 'services/context/MainContext';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';

const CustomBottomNavigation = styled(BottomNavigation)(
    ({ theme }) => `
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 80px;
        background-color: ${theme.palette.secondary.main};
        z-index: 99;
        border-radius: 10px 10px 0 0;


        ${theme.breakpoints.up("lg")} {
            width: 400px !important;
            right: 50%;
            transform: translateX(50%);
            left: unset;
        }
    `
)

export default function BottomNavigationMenu() {

    const [value, setValue] = useState("");

    const navigate = useNavigate()
    const location = useLocation()

    const { ticketList, userInfo } = useContextState()

    useEffect(() => {
        setValue(window.location.pathname)
    }, [location])

    const handleChange = (event, newValue) => {
        setValue(newValue);
    }

    const handleUnreadCount = (tickets) => {
        if(tickets) {
            return tickets?.filter(ticket => ticket.UnreadMessages > 0).length
        }
    }

  return (
    <CustomBottomNavigation showLabels value={value} onChange={handleChange}>
        <BottomNavigationAction
            disableRipple={true}
            label="پشتیبانی"
            value={urlSupportPage}
            icon={
                <Badge badgeContent={handleUnreadCount(ticketList)} color='badgeGrey' sx={{"& .MuiBadge-badge": {color: "green !important", fontWeight: "bold"}}} >
                    <SupportsIcon />
                </Badge>
            }
            onClick={() => navigate(urlSupportPage)}
        />
        <BottomNavigationAction
            disableRipple={true}
            label="اعلان ها"
            value={urlNotifPage}
            icon={
                <Badge
                    badgeContent={userInfo.Notification || 0}
                    anchorOrigin={{ vertical: 'top', horizontal: 'left', }}
                    color="error"
                    sx={{
                        "& .MuiBadge-badge": {
                            top: "2px",
                            left: "4px"
                        }
                    }}
                >
                    <NotificationsOutlinedIcon sx={{width: "28px", fontSize: "28px"}} color="primary" />
                </Badge>
            }
            onClick={() => navigate(urlNotifPage)}
        />
        <BottomNavigationAction
            disableRipple={true}
            label="خانه"
            value={"/"}
            icon={<HouseIcon />}
            onClick={() => navigate("/")}
        />
        <BottomNavigationAction
            disableRipple={true}
            label="بارکدخوان"
            value={urlBarcodePage}
            icon={<BarcodeIcon />}
            onClick={() => navigate(urlBarcodePage)}
        />
        <BottomNavigationAction
            disableRipple={true}
            label="جوایز"
            value={urlAwardsPage}
            icon={<WrappedGiftIcon />}
            onClick={() => navigate(urlAwardsPage)}
        />
    </CustomBottomNavigation>
  )
}